<template>
    <c-widget-filter class="widget-title">
        <slot></slot>
    </c-widget-filter>
</template>

<script>
import { CWidgetFilter } from './Styles/Product/styled'

export default {
    name: 'WidgetTitleFilter',
    components: {
        'c-widget-filter': CWidgetFilter
    }
}
</script>